export default {
  'xxl': 2500,
  // 'xl': 1920,
  'lg': 1200,
  // 'md': 996,
  'sm': 480,
  'xs': 0
}
